/**
 * TKP-83 / tasarım s.16 — yeni çalışma alanının kütüphanesi neyle başlar? Seçim yalnız yönetici panelinde sorulur.
 * TKP-245 (karar 2026-11-03): varsayılan BOŞ — kütüphane, organizasyon, birim, süreç boş; sonra isterse Excel'den içe aktarılır.
 * Kullanıcının kendi açtığı çalışma alanı da boş başlar.
 */
export const LibraryStart = Object.freeze({ TUNESOFT: "TUNESOFT", EMPTY: "EMPTY" });
export const LibraryMode = Object.freeze({ SHARED: "SHARED", LOCAL: "LOCAL" });

export const libraryStartOptions = () => [
  { value: LibraryStart.EMPTY, labelKey: "workspace.library.start-empty", hintKey: "workspace.library.start-empty-hint" },
  { value: LibraryStart.TUNESOFT, labelKey: "workspace.library.start-tunesoft", hintKey: "workspace.library.start-tunesoft-hint" },
];

/** Alanı olmayan (TKP-81 öncesi) çalışma alanı PAYLAŞIMLI'dır. */
export const libraryModeOf = (workspace) => (workspace && workspace.libraryMode === LibraryMode.LOCAL ? LibraryMode.LOCAL : LibraryMode.SHARED);
export const libraryModeLabelKey = (workspace) => (libraryModeOf(workspace) === LibraryMode.LOCAL ? "workspace.library.mode-local" : "workspace.library.mode-shared");

/** Oluşturma gövdesi: seçim yalnız YENİ çalışma alanında gönderilir; güncellemede kip/başlangıç verisi yollanmaz. */
export const buildSavePayload = (form, libraryStart) => {
  const { libraryMode, ...workspace } = form || {};
  return workspace._id ? { workspace } : { workspace, libraryStart: libraryStart || LibraryStart.EMPTY };
};

/** Tohumlama eylemi neden kapalı? Açıksa `null`. */
export const seedBlockedReasonKey = (status) => {
  if (!status) return "workspace.library.seed-status-loading";
  if (status.mode !== LibraryMode.LOCAL) return "workspace.library.seed-blocked-shared";
  if (status.ownRecords > 0) return "workspace.library.seed-blocked-not-empty";
  return null;
};

/** TKP-171 — yerelleştirme raporu → onay/sonuç metni parametreleri (kopya, eşlenen referans, taranan kayıt). */
export const localizeSummary = (report) => ({
  copied: (report && report.copy && report.copy.copied) || 0,
  seeded: (report && report.copy && report.copy.alreadySeeded) || 0,
  refs: (report && report.remapTotals && report.remapTotals.changedRefs) || 0,
  docs: (report && report.remapTotals && report.remapTotals.changedDocs) || 0,
});
